import React, { useId, useState } from "react";

export function ActionTooltip({
  label,
  children,
}: {
  label: string;
  children: (descriptionId: string | undefined) => React.ReactNode;
}) {
  const id = useId();
  const [open, setOpen] = useState(false);

  return (
    <span
      className="cp-action-tooltip"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      onClick={() => setOpen(false)}
      onKeyDown={(event) => {
        if (event.key === "Escape") setOpen(false);
      }}
    >
      {children(open ? id : undefined)}
      {open ? (
        <span id={id} role="tooltip" className="cp-action-tooltip__content">
          {label}
        </span>
      ) : null}
    </span>
  );
}
